export default "__VITE_ASSET__9fb57baf__"